import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import FormInput from '../../common/FormInput';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../auth/Auth';
import { HiOutlineArrowLeft } from '@react-icons/all-files/hi/HiOutlineArrowLeft';
import DashboardHeader from '../../header/DashboardHeader';
import LoadButton from '../../common/LoadButton';
import { VERIFICATION_PAYMENT_SUCCESS_ROUTE } from "../../../constants/routes.constants";
import PaymentMethod from "../../../assets/images/payment-method.svg";
import { ERROR_REQUIRE_MSG } from '../../../constants/error.constants';
import { getStripeApiKey } from '../../../utils/config.utils';
import { stripeViewModel } from '../payment/stripe.view.model';
import { priceWithDollerSign } from '../../../utils/utils';
import { loadStripe } from '@stripe/stripe-js';
import {
  Elements,
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js';

import '../payment/scss/paymentMethod.scss';
import Footer from '../../footer/Footer';

const VerificationPaymentForm = ({ dependentId }) => {
  const { guardian, refreshUserState, fetchAPI } = useAuth();
  const stripe = useStripe();
  const elements = useElements();
  const { register, handleSubmit } = useForm();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState('');
  const [paymentMethodInfo, setPaymentMethodInfo] = useState(null);
  const [cardHolderName, setCardHolderName] = useState(
    guardian.first_name + ' ' + guardian.last_name
  );
  const [isLoading, setIsLoading] = useState(false);
  // const [price, setPrice] = useState();

  // const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  // const [promoErrorMessage, setPromoErrorMessage] = useState('');
  // const [totalAmount, setTotalAmount] = useState();

  const pageRedirect = () => {
    history.goBack();
  }

  const options = {
    style: {
      base: {
        fontSize: '1.4rem',
        color: '#424770',
        letterSpacing: '0.025em',
        height: '51px',
        marginTop: '2px',
        fontFamily: 'Source Code Pro, monospace',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };

  const handleContinue = async () => {
    createNewPaymentMethod();
  };

  const createNewPaymentMethod = async () => {
    setIsLoading(true);
    const cardElement = elements.getElement(CardNumberElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: {
        name: cardHolderName,
      },
    });

    if (error) {
      // console.log('[createPaymentMethod error]', error);
      setErrorMessage(error.message);
      setIsLoading(false);
    } else {
      // console.log('[PaymentMethod]', paymentMethod);
      setPaymentMethodInfo(paymentMethod);
      // getPrices(paymentMethod);
      handleSubscribe(paymentMethod);
      // setDefaultPlan(paymentMethod)
    }
  };

  const handleSubscribe = (method) => {
    setErrorMessage('');
    const req = {
      payment_method_id: method.id,
      dependent_id: dependentId,
      amount: 0.80
    };
    getPrices(method)
    // stripeViewModel.verificationPayment(req).then((response) => {
    //   // refreshUserState();
    //   getPrices(method)
    //   // history.push(VERIFICATION_PAYMENT_SUCCESS_ROUTE);
    // }).catch((err) => {
    //   setIsLoading(false);
    // });
  };

  const setDefaultPlan = (method, price) => {
    // const subscription = {
    //   payment_method_id: method.id,
    //   price_id: price.id,
    //   dependent_ids: [guardian.dependents[0].id]
    // }
    const subscription = {
      payment_method_id: method.id,
      amount: price.unit_amount,
      price_id: price.id,
      dependent_id: dependentId,
      plan: "seedlings"
    }
    if (price) {
      // stripeViewModel.subscribe(subscription).then((res) => {
      // stripeViewModel.paymentIntentSeedlings(subscription).then((res) => {
      //   refreshUserState();
      //   history.push(VERIFICATION_PAYMENT_SUCCESS_ROUTE);
      // }).catch((err) => {
      //   console.log(err)
      // })
      const req = {
        payment_method_id: method.id,
        dependent_id: dependentId,
        amount: price.unit_amount
      };
      stripeViewModel.verificationPayment(req).then((response) => {
        refreshUserState();
        // getPrices(method)
        history.push(VERIFICATION_PAYMENT_SUCCESS_ROUTE);
      }).catch((err) => {
        setIsLoading(false);
      });
    }
  }

  const getPrices = (method) => {
    // setDefaultPlan(method)
    fetchAPI(stripeViewModel.getPrices, 'one_time')
      .then((res) => {
        res.map((price) => {
          if (price.nickname === "Seedlings") {
            // setPrice(price.id)
            setDefaultPlan(method, price)
          }
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // const handlePromotionCode = () => {
  //   if (promotionInfo === '') {
  //     promotionCodeInput.current.focus();
  //     return;
  //   }
  //   stripeViewModel
  //     .checkPromoCode({
  //       code: promotionInfo,
  //     })
  //     .then((res) => {
  //       if (res.duration === 'once' && res.times_redeemed > 1) {
  //         console.log('Already used this promotion code');
  //       } else if (!res.coupon.valid) {
  //         console.log('reject');
  //       } else {
  //         setTotalAmount(priceWithDollerSign(res.total));
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       // setShowErrorMessage('show')
  //       if (err.statusCode === 404)
  //         setPromoErrorMessage(err.serverResponse.error_info);
  //       else if (err.statusCode === 400)
  //         setPromoErrorMessage(err.serverResponse.error_info);
  //       else setPromoErrorMessage('');
  //     });
  // };

  return (
    <div>
      <DashboardHeader />
      <div className='add-more-branches verification-gaurdian'>
        <span className="back-btn" onClick={pageRedirect}><HiOutlineArrowLeft /></span>

        <Container>
          <div className="d-flex justify-content-center">
            <div>
              <h2 className='text-center mb-100'>Verification</h2>
              <Form className='mt-50 mb-40' onSubmit={handleSubmit(handleContinue)}>
                <div className="d-flex justify-content-start mt-50">
                  <div>
                    <h3>Summary</h3>
                    <Row className='mt-4 verification-fee fw-normal'>
                      <Col xs={9}>Verification fee</Col>
                      <Col xs={3}>$0.80</Col>
                    </Row>
                    {/* <Row className='mt-4'>
                      <Col xs={12} className="fw-normal">Get 10 seeds worth $1 added to your kids's account.</Col>
                    </Row> */}
                    <hr />
                    <Row className='mt-3 bm-3'>
                      <Col xs={9}><h4><b>Pay Now</b></h4></Col>
                      <Col xs={3}><h4><b>$0.80</b></h4></Col>
                    </Row>

                    <hr />


                    <div className='payment-methods mb-4'>
                      <img src={PaymentMethod} style={{ maxHeight: '30px' }} alt='' />
                    </div>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <FormInput
                        name="name_on_card"
                        className="form-input"
                        ref={register({
                          required: ERROR_REQUIRE_MSG,
                        })}
                        placeholder="Name on Card"
                        defaultValue={cardHolderName}
                        onChange={(e) => {
                          setErrorMessage('');
                          setCardHolderName(e.target.value);
                        }}
                        data-testid="name_on_card"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <CardNumberElement
                        options={options}
                        className="form-input form-control"
                        placeholder="Card Number"
                        showIcon={true}
                        onChange={(event) => {
                          setErrorMessage('');
                        }}
                      />
                    </Form.Group>

                    <Row>
                      <Col>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <CardExpiryElement
                            options={options}
                            className="form-input form-control"
                            placeholder="EXP"
                            onChange={(event) => {
                              setErrorMessage('');
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <CardCvcElement
                            options={options}
                            className="form-input form-control"
                            placeholder="CVC"
                            onChange={(event) => {
                              setErrorMessage('');
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* <Row>
                      <Col>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <FormInput
                            name="promotion_code"
                            ref={promotionCodeInput}
                            placeholder="Promo code"
                            data-testid="promotion_code"
                            onChange={(e) => {
                              setPromoErrorMessage('');
                              setPromotionInfo(e.target.value);
                            }}
                            value={promotionInfo}
                            disabled={disablePromotion}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Button className='w-100' variant="secondary" type="submit" disabled>
                          Apply
                        </Button>
                      </Col>
                    </Row> */}


                    <div className="mt-4">
                      <h4><b>Why is a credit card needed for children under 13?</b></h4>
                    </div>
                    {/* <div className="mt-4">
                      Account verification keeps our community safe and gives your child<br /> 
                      access to the full features of TaleTree, including being able to earn, <br />
                      gift and purchase 'seeds'.
                    </div> */}
                    <div className="mt-4">
                      In accordance with the Child Online Privacy Protection Act (COPPA),<br />
                      a parent or guardian must provide consent to set up a TaleTreeAccount<br />
                      for children under age 13.
                    </div>
                    <div className='mt-4'>
                      A one-time fee of $0.80 is charged to verify that a parent or guardian<br />
                      has provided consent. This one-time payment is a commonly used and<br />
                      accepted parental control method required so that parents have the<br />
                      chance to see the payment on their credit card statement,<br />
                      and to alert TaleTree if consent was improperly provided.
                    </div>
                    {/* <div className='mt-4'>
                      By verifying your account, we know who you are and your child are<br />
                      which is so very important to us.
                    </div>
                    <div className='mt-4'>
                      After Verification your child will have a blue tick next to its profile,<br />
                      letting the community know that you have completed this<br />
                      important action.
                    </div>
                    <div className='mt-4 mb-4'>
                      Thank you for keep your child and all TaleTree children, safe.
                    </div> */}

                    <div className="error-message mt-80 text-center text-danger">{errorMessage}</div>

                    <LoadButton
                      isLoading={isLoading}
                      isDisabled={isLoading}
                      type="submit"
                      text="VERIFY YOUR ACCOUNT"
                      // onClick={() => history.push(VERIFICATION_PAYMENT_SUCCESS_ROUTE)}
                      className="gred-btn submit-btn mt-2 w-100 change-password-button btn-success txt-white"
                    />
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </Container>
      </div>
      <Footer />
    </div>
  );
}


const VerificationPayment = () => {
  const history = useHistory();
  const dependentId = history?.location?.state?.dependentId
  const stripePromise = loadStripe(getStripeApiKey());

  return (
    <Elements stripe={stripePromise}>
      <VerificationPaymentForm dependentId={dependentId} />
    </Elements>

  )
}
export default VerificationPayment;